import { render } from "./AutoMap.vue?vue&type=template&id=50a1c30a"
import script from "./AutoMap.vue?vue&type=script&lang=js"
export * from "./AutoMap.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__